// Free, no-key random avatars from DiceBear. We point an <img> at the SVG
// endpoint with a random seed; the server only accepts URLs on this host.

const STYLES = [
  "adventurer",
  "big-smile",
  "bottts",
  "fun-emoji",
  "lorelei",
  "micah",
  "open-peeps",
  "thumbs",
];

export function randomSeed(): string {
  return Math.random().toString(36).slice(2, 10);
}

export function randomStyle(): string {
  return STYLES[Math.floor(Math.random() * STYLES.length)];
}

export function avatarUrl(style: string, seed: string): string {
  return `https://api.dicebear.com/9.x/${style}/svg?seed=${encodeURIComponent(seed)}`;
}
